import { createRouter } from '@tanstack/react-router';
import ErrorPage from 'pages/errorPage/errorPage.component';
// Import the generated route tree
import { routeTree } from 'routeTree.gen';

// Create a new router instance
const router = createRouter({
  routeTree,
  basepath: '/private-area',
  defaultErrorComponent: ErrorPage,
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export { router };
